var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.0008 1.65C13.0008 1.29101 13.2918 1 13.6508 1C14.0098 1 14.3008 1.29101 14.3008 1.65V5.64996C14.3008 6.00895 14.0098 6.29996 13.6508 6.29996H9.65038C9.2914 6.29996 9.00038 6.00895 9.00038 5.64996C9.00038 5.29098 9.2914 4.99996 9.65038 4.99996H12.43C10.872 2.69415 7.77236 1.9538 5.32505 3.36675C2.76618 4.84411 1.88945 8.11612 3.36681 10.675C4.84417 13.2339 8.11618 14.1106 10.675 12.6332C12.1115 11.8039 13.0179 10.4099 13.2754 8.89128C13.3355 8.53735 13.671 8.29909 14.025 8.35911C14.3789 8.41914 14.6172 8.75471 14.5571 9.10864C14.2376 10.9927 13.111 12.728 11.325 13.7591C8.1444 15.5954 4.07733 14.5056 2.24098 11.325C0.404633 8.14434 1.4944 4.07727 4.67505 2.24092C7.47116 0.626583 10.9523 1.27361 13.0008 3.61454V1.65Z","fill":"currentColor"}));
}

Refresh.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Refresh;

Refresh.default = Refresh;
